import { skipNavStyles } from "@insite/content-library/Components/SkipNav";
import { css } from "styled-components";

Object.assign(skipNavStyles, {
    skipToContent: {
        variant: "primary",
        css: css`
            margin: 4px;
            position: absolute;
            clip: rect(0, 0, 0, 0);
            z-index: 99;

            &:focus {
                clip: unset;
            }
        `,
    },
});
